import React from "react";
import CheckPRNDialog from "../dialog/CheckPRN";
import PermitStatus from "../dialog/PermitStatus";
import CertificateDetails from "../dialog/CertificateDetails";

export const Modals = () => {
  return (
    <>
      <CheckPRNDialog />
      <PermitStatus />
      <CertificateDetails />
    </>
  );
};
